module.exports = __webpack_public_path__ + "static/media/Logo_black_plain.7fa50280.svg";